import axios, {CancelToken} from 'axios';
import {Effect} from 'effect';
import {InterruptedException, UnknownException} from 'effect/Cause';

import ProjectsApi from 'api/projects';
import {TaskDependencyDto} from 'shared/models/TaskDependency';

import {ApiResponse} from '../BatchLoader';
import {BadGatewayError, EffectError, HttpError} from '../errors';

export const createProjecDepsEffect = ({projectId, taskIds}: {projectId: string; taskIds: string[]}) => {
  return (
    offset: number,
    take: number,
    cancelToken: CancelToken,
  ): Effect.Effect<ApiResponse<TaskDependencyDto>, EffectError, never> =>
    Effect.tryPromise({
      try: () =>
        ProjectsApi.getTaskDependencies(projectId, taskIds, {
          offset,
          limit: take,
          cancelToken,
        }),
      catch: (error): EffectError => {
        if (axios.isCancel(error)) {
          return new InterruptedException('Request cancelled');
        }

        if (axios.isAxiosError(error)) {
          switch (error.response?.status) {
            case 502:
              return new BadGatewayError({
                message: error.message,
                cause: error,
              });
            default:
              return new HttpError({
                statusCode: error.response?.status || 500,
                message: error.message,
                cause: error,
              });
          }
        }

        return new UnknownException({
          message: error instanceof Error ? error.message : 'Unknown error',
          cause: error instanceof Error ? error : undefined,
        });
      },
    }).pipe(
      Effect.map((response) => ({
        data: response.data.dependencies,
        headers: response.headers,
      })),
    );
};
